import { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useIsAssistantAvailable } from '@/hooks/useIsAssistantAvailable';
import { AssistantChatView } from './AssistantChatView';
import { useAssistantChatTurn } from './useAssistantChatTurn';
import { AssistantHistoryView } from './AssistantHistoryView';
import { AssistantPanelHeader } from './AssistantPanelHeader';
import { useAssistantPanel } from './assistantPanelContext';
import { isSmallScreen } from './mediaQueries';
import { useAssistantPanelFocus } from './useAssistantPanelFocus';
import { AssistantVoiceView } from './voice/AssistantVoiceView';

export function AssistantPanel() {
  const { t } = useTranslation('assistant');
  const isAvailable = useIsAssistantAvailable();
  const { isOpen, view, selectConversation } = useAssistantPanel();
  const turn = useAssistantChatTurn();
  const panelRef = useRef<HTMLElement | null>(null);
  const isVisible = isAvailable && isOpen;
  useAssistantPanelFocus(panelRef, isVisible);
  if (isVisible === false) {
    return null;
  }
  return (
    <aside
      ref={panelRef}
      role="dialog"
      aria-modal={isSmallScreen() ? true : undefined}
      aria-label={t('panel.title')}
      data-assistant-panel="true"
      className="fixed inset-0 z-50 bg-zoowhite flex flex-col lg:static lg:inset-auto lg:z-auto lg:w-[400px] lg:shrink-0 lg:h-full lg:border-l lg:border-zooborder"
    >
      <AssistantPanelHeader
        onNewChat={function startNewChat() {
          turn.clear();
          selectConversation(null);
        }}
      />
      {view === 'history' ? <AssistantHistoryView /> : null}
      {view === 'voice' ? <AssistantVoiceView /> : null}
      {view === 'chat' ? <AssistantChatView turn={turn} /> : null}
    </aside>
  );
}
